import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { HomeReducer } from './homeReducer'

export default (history) => combineReducers({
    router: connectRouter(history),
    HomeReducer
})